import { createRouter, createWebHistory } from "vue-router";
import HomeContainer, { STEP_CHECKOUT } from "@/pages/HomeContainer";
import SignupWaitList from "@/pages/SignupWaitListPage";
import WaitListComplete from "@/pages/WaitListComplete";
import ConnectACHPage from "@/pages/ConnectACHPage";

const routes = [
  {
    path: "/",
    redirect: "/wait-list/",
  },
  {
    path: "/signup-and-pay/",
    redirect: "/signup-and-pay/owner/",
  },
  {
    path: "/signup-and-pay/:step/",
    name: "SignupAndPay",
    component: HomeContainer,
    props: {
      paymentEnabled: true,
      showDashboardURLAtComplete: true,
      readonlySignature: false,
      newSignupUrl: "/signup-and-pay/",
    },
  },
  {
    path: "/wait-list/",
    name: "SignupToWaitList",
    component: SignupWaitList,
  },
  {
    path: "/wait-list/completed/",
    name: "WaitListComplete",
    component: WaitListComplete,
  },
  {
    path: "/payment/:id",
    name: "Payment",
    component: HomeContainer,
    props: (route) => ({
      id: route.params.id,
      paymentEnabled: true,
      showDashboardURLAtComplete: true,
      readonlySignature: false,
      initStep: STEP_CHECKOUT,
      newSignupUrl: "/signup-and-pay/",
    }),
  },
  {
    path: "/connect-ach/:uuid/",
    name: "ConnectACH",
    component: ConnectACHPage,
    props: (route) => ({
      businessUUID: route.params.uuid,
    }),
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

export default router;
